import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "72",
  height: "72",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "72",
      height: "72",
      fill: "#F24141",
      rx: "36"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M36 40.188q.594 0 1.016-.422.437-.438.437-1V23.984l-.125-2.187.703.922 2.172 2.312q.39.422.969.422.531 0 .906-.344.375-.36.375-.89 0-.516-.39-.922l-4.954-4.766a1.7 1.7 0 0 0-.562-.39 1.4 1.4 0 0 0-.547-.11q-.296 0-.578.11-.266.11-.547.39l-4.938 4.766q-.405.406-.406.922 0 .53.375.89.375.345.89.344.595 0 .985-.422l2.172-2.312.703-.922-.125 2.187v14.782q0 .562.422 1 .437.421 1.047.422m-8.531 11.874h10.343a3.8 3.8 0 0 1-.468-1.5 4.2 4.2 0 0 1 .218-1.64h-9.859q-.984 0-1.515-.516-.516-.515-.516-1.547V33q0-1.047.515-1.547.532-.516 1.516-.515h3.766v-3.125h-4q-2.422 0-3.688 1.234-1.25 1.234-1.25 3.656v14.469q0 2.39 1.25 3.64 1.266 1.25 3.688 1.25M49.453 34.61v-1.906q0-2.406-1.25-3.64-1.25-1.25-3.687-1.25h-3.953v3.125h3.718q.985 0 1.516.515.531.501.531 1.547v1.61a3.6 3.6 0 0 1 2.375-.266q.39.093.75.265M41.5 52.047h12.797q.953 0 1.531-.625.578-.61.578-1.484 0-.547-.281-1.032l-6.406-11.453a2.06 2.06 0 0 0-.797-.812 2.08 2.08 0 0 0-2.063.015 2 2 0 0 0-.78.797l-6.407 11.453a2.1 2.1 0 0 0-.281 1.032q0 .875.578 1.484.578.625 1.531.625m6.39-2.234a1.35 1.35 0 0 1-.968-.391q-.39-.375-.39-.953a1.33 1.33 0 0 1 1.359-1.344q.593 0 .984.39.406.407.39.954 0 .578-.39.953-.39.39-.984.39Zm.016-3.641a1.05 1.05 0 0 1-.75-.281 1 1 0 0 1-.297-.703l-.109-4.063q-.015-.516.297-.828.328-.328.86-.328.514 0 .843.328.328.312.313.828l-.126 4.063a.98.98 0 0 1-.312.703.97.97 0 0 1-.719.28Z"
    }, null, -1)
  ])))
}
export default { render: render }